<span>
  <slot></slot>
</span>

<style>
  span {
    display: inline-flex;
  }
</style>
